import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import { Avatar } from "@mui/material";

import { fireSafetyRoles, utilityTunnelAllRoles } from "common/constant";
import { layoutModeTypes } from "Components/constants/layout";
import {
  fireSafetyHomeRoute,
  homeRoute,
  profileRoute,
  utilityTunnelHomeRoute,
  utilityTunnelProfileRoute,
} from "Routes/constants";

import { logoutUserSuccess } from "slices/auth/login/reducer";
import { api } from "slices/api";
import { getImageUrl, isAuthorizedUser } from "utils";
import { changeLayoutMode } from "slices/thunks";

const ProfileDropdown = ({ t }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const user = useSelector((state) => state.Login.user);
  const { roles } = useSelector((state) => state.Login);

  const [userName, setUserName] = useState("Admin");

  const isFireSafety = isAuthorizedUser(roles, fireSafetyRoles);
  const isUtilityTunnel = isAuthorizedUser(roles, utilityTunnelAllRoles);

  useEffect(() => {
    if (sessionStorage.getItem("authUser")) {
      const obj = JSON.parse(sessionStorage.getItem("authUser"));
      setUserName(
        process.env.REACT_APP_DEFAULTAUTH === "fake"
          ? obj.username === undefined
            ? user.first_name
              ? user.first_name
              : obj.data.first_name
            : "Admin" || "Admin"
          : process.env.REACT_APP_DEFAULTAUTH === "firebase"
          ? obj.providerData[0].email
          : "Admin"
      );
    }
  }, [userName, user]);

  //Dropdown Toggle
  const [isProfileDropdown, setIsProfileDropdown] = useState(false);
  const toggleProfileDropdown = () => {
    setIsProfileDropdown(!isProfileDropdown);
  };

  return (
    <Dropdown isOpen={isProfileDropdown} toggle={toggleProfileDropdown}>
      <DropdownToggle tag="button" type="button" className="btn">
        <span className="d-flex align-items-center">
          <Avatar
            src={user.profileImage ? getImageUrl(user.profileImage) : ""}
            sx={{ bgcolor: "#0175be", color: "#fff" }}
          >
            {!user.profileImage &&
              `${user.firstName[0]}${user.lastName ? user.lastName[0] : ""}`}
          </Avatar>

          <span className="text-start ms-xl-2">
            <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text text-white">
              {user &&
                `${user.firstName} ${user.lastName ? user.lastName : ""}`}
            </span>
          </span>
        </span>
      </DropdownToggle>
      <DropdownMenu className="dropdown-menu-end" style={{ zIndex: 9999 }}>
        <DropdownItem className="p-0">
          <Link
            to={
              isFireSafety
                ? "/fire-safety/profile"
                : isUtilityTunnel
                ? utilityTunnelProfileRoute
                : profileRoute
            }
            className="dropdown-item"
          >
            <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1" />
            <span className="align-middle">{t("Profile")}</span>
          </Link>
        </DropdownItem>
        <div className="dropdown-divider"></div>
        <DropdownItem className="p-0">
          <span
            className="dropdown-item"
            onClick={() => {
              dispatch(logoutUserSuccess());
              dispatch(changeLayoutMode(layoutModeTypes["LIGHTMODE"]));
              dispatch(api.util.resetApiState());

              navigate(
                window.location.href.includes("fire-safety")
                  ? fireSafetyHomeRoute
                  : window.location.href.includes("utility-tunnel")
                  ? utilityTunnelHomeRoute
                  : homeRoute,
                { replace: true }
              );
            }}
          >
            <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />
            <span className="align-middle" data-key="t-logout">
              {t("Logout")}
            </span>
          </span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

ProfileDropdown.propTypes = {
  t: PropTypes.func,
};

export default withTranslation()(ProfileDropdown);
